import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { Booking, api, IAssetKeysAtLocationPath } from "../../../logic/api";
import usePaths from "../../../utility/paths";
import styles from "../styles";
import { PagedDataView } from "../../../components/lists/PagedDataView/PagedDataView";
import KeyLocationListItem from "../../../components/lists/listItems/KeyLocationListItem/KeyLocationListItem";
import KeyRow from "./condensedLayout/key/KeyRow";
import HeaderRow from "./condensedLayout/HeaderRow";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useReleaseManagement, ReleaseFlag } from "../../../utility/feature-management";

const KeysAtLocation: React.FunctionComponent<{
  isCondensedView?: boolean;
  path: string;
}> = (props) => {

  const { t } = useTranslation();
  const paths = usePaths();
  const history = useHistory();
  const [params, setParams] = useState<IAssetKeysAtLocationPath>({
    path: props.path
  });
  const isOpenLinksInNewTab = useReleaseManagement(ReleaseFlag.releaseOpenLinksInNewTabs);

  useEffect(() => {
    if (props.path != params.path) {
      setParams({
        ...params, path: props.path
      });
    }
  }, [props.path]);

  const handleGoToBooking = (bookingId: number) => {
    if (isOpenLinksInNewTab) {
      window.open(paths.booking(bookingId), "_blank");
    } else {
      history.push(paths.booking(bookingId));
    }
  }

  return <div>
    {props.isCondensedView ? (<PagedDataView<IAssetKeysAtLocationPath, Booking>
      apiHook={api.hooks.assetVehicleKey.getAtLocation}
      parameters={params}
      header={() => <HeaderRow columnHeaders={[t("booking.cards.status"), t("booking.labels.ref"), t("booking.labels.keyLocation"), t("locations.vehicleReg"), t("booking.cards.vehicle"), t("locations.expectedReturn"), ""]} />}
      isTable
      animate={false}
      renderItem={(item, index) => {
        return <KeyRow booking={item} rowIndex={index} onClick={() => handleGoToBooking(item.id)} />
      }}
    ><div style={styles.noDataCondensed}>
        {t("locations.noKeysFoundAtLocation")}
      </div>
    </PagedDataView>)
      :
      (<div>
        <PagedDataView<IAssetKeysAtLocationPath, Booking>
          apiHook={api.hooks.assetVehicleKey.getAtLocation}
          parameters={params}
          renderItem={(item) => {
            return <KeyLocationListItem booking={item} onClick={() => handleGoToBooking(item.id)} />
          }}
        >
          <div style={styles.noData}>
            {t("locations.noKeysFoundAtLocation")}
          </div>
        </PagedDataView>
      </div>)}
  </div>
};

KeysAtLocation.propTypes = {
  path: propTypes.string.isRequired
}

export default KeysAtLocation;
